// AI Chat Constants

export const AI_ASSISTANT = {
  name: 'Inny',
  initial: 'I',
  tagline: "I'm Inny, here to help with your business data",
};

export const TIME_GREETINGS: Record<string, string[]> = {
  morning: ['Good morning', 'Rise and shine', 'Hello, early bird'],
  afternoon: ['Good afternoon', 'Hello there', 'Hey'],
  evening: ['Good evening', 'Hello', 'Hey there'],
  night: ['Working late?', 'Burning the midnight oil?', 'Hello, night owl'],
};

export const INVITATIONS = [
  "What can I help you explore today?",
  "Ask me anything about your business data.",
  "Ready to dive into your analytics?",
  "How can I assist you?",
  "What would you like to know?",
];

export const QUICK_SUGGESTIONS = [
  { icon: 'Users', text: "Show me today's schedule", color: 'text-blue-500' },
  { icon: 'Star', text: "What are my recent reviews?", color: 'text-amber-500' },
  { icon: 'TrendingUp', text: "How is business this week?", color: 'text-green-500' },
];

export const THINKING_PHRASES = [
  'Thinking',
  'Analyzing',
  'Searching',
  'Processing',
  'Looking up',
];

// Typewriter effect settings
export const TYPEWRITER_SPEED_MS = 15;
